import { RequestInputOutputParamsModel } from "../models/requestInputOutputParams.model";
import { ResultRequestModel } from "../models/resultRequest.model";
import { HttpService } from "./http.service";

const basePath = "/DashboardBranch";
const request = HttpService.handleRequest();

export const DashboardBranchService = {
  getList,
  updateEquipmentPickupDate,
  updateEquipmentPickupStatus,
  getChangeDay,
  requestCancellationSiga
};

async function getList(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/EquipmentListWithPagination`, data);
}

async function updateEquipmentPickupDate(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.put(`${basePath}/UpdateEquipmentPickupDate`, data);
}

async function updateEquipmentPickupStatus(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.put(`${basePath}/UpdateEquipmentPickupStatus`, data);
}

async function getChangeDay(idEquipment, datePickup){
  return request.get(`${basePath}/ChangeDay/${idEquipment}/${datePickup}`);
}

async function requestCancellationSiga(data: RequestInputOutputParamsModel): Promise<ResultRequestModel> {
  return request.post(`${basePath}/RequestCancellationSiga`, data);
}

export default DashboardBranchService;